class TextMeasurer {
  #element: HTMLPreElement;
  #cache = new Map<string, number>();

  constructor() {
    this.#element = document.createElement('pre');
    this.#element.style.position = 'absolute';
    this.#element.style.visibility = 'hidden';
    this.#element.style.whiteSpace = 'pre';
    document.body.appendChild(this.#element);
  }

  measure(string: string, font: string) {
    const key = `${string}:${font}`;
    const cachedWidth = this.#cache.get(key);

    if (cachedWidth) {
      return cachedWidth;
    }

    this.#element.style.font = font;
    this.#element.textContent = string;

    const width = this.#element.getBoundingClientRect().width;

    this.#cache.set(key, width);

    return width;
  }

  cleanup() {
    document.body.removeChild(this.#element);
  }
}

export const textMeasurer = new TextMeasurer();
